import React from 'react';

import { Card, Stack, Text } from '@mantine/core';

import { UMIScatterPlot } from './UMIScatterPlot';
import { CellResponse } from '../generated/generatedOpenAPI';

interface IgExpressionProps {
  hasIgIsotype: boolean;
  typeOfRanAnalysis: 'A' | 'B';
  cellData: CellResponse[] | undefined;
  isLoading?: boolean;
}

export default function IgExpression(props: IgExpressionProps) {
  return (
    <Card withBorder>
      <Stack gap="xl">
        <Text>Ig Expression Distribution</Text>
        <UMIScatterPlot {...props} />
      </Stack>
    </Card>
  );
}
